export default __webpack_public_path__ + "static/media/pbn-wires.201b027d.webp";